import React from 'react';
import { Helmet } from 'react-helmet';
import * as API from 'generated/api';

// give us a TTL for now in case we mess up
// ms/s * s/min * min/hour * hour/day
const INDEX_TTL = (1000 * 60 * 60 * 24) * 7;

interface Props {
  chat: API.FFPublicChat;
}

// Updates <head> tags on mount for pages primarily showing a chat.
export const ChatHeader = ({ chat }: Props) => (
  <Helmet>
    <title>{chat.name || 'Muze'}</title>
    <meta property="og:title" content={chat.name || 'Muze'} />
    {chat.profileImageLarge && (
      <meta property="og:image" content={chat.profileImageLarge} />
    )}
    {chat.profileImageSmall && (
      <link rel="apple-touch-icon" href={chat.profileImageSmall} />
    )}
    <meta
      name="robots"
      content={
        `unavailable_after: ${new Date(Date.now() + INDEX_TTL).toISOString()}`
      } 
    />
  </Helmet>
);

export default ChatHeader;
